module.exports = __webpack_public_path__ + "img/fw_workflow_2.e12dadf2.png";